import { ReactNode } from 'react';

type Tone = 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'accent' | 'navy' | 'draft' | 'neu';

const TONE_CLASSES: Record<Tone, string> = {
  primary: 'bg-mist text-primary',
  secondary: 'bg-mist text-muted-2',
  success: 'bg-success-bg text-success',
  warning: 'bg-warning-bg text-warning-ink',
  danger: 'bg-danger-bg text-danger-ink',
  info: 'bg-mist text-muted-2',
  // Design `.p-mute` / `.p-none`.
  neutral: 'bg-ground text-muted',
  // Design `.p-acc` / `.p-hot`.
  accent: 'bg-accent-bg text-accent-ink',
  // Design `.p-navy` (stays navy in dark).
  navy: 'bg-navy text-white',
  // Design `.p-draft`: ground fill with a line-strong inset ring.
  draft: 'bg-ground text-muted-2 shadow-[inset_0_0_0_1px_rgb(var(--yd-line-strong))]',
  // Design `.p-neu` (CP).
  neu: 'bg-neu-bg text-neu-ink',
};

interface Props {
  tone?: Tone;
  size?: 'sm' | 'md';
  children: ReactNode;
  className?: string;
}

export default function Badge({ tone = 'neutral', size = 'sm', children, className = '' }: Props) {
  const sz = size === 'sm' ? 'text-xs px-2.5 py-1' : 'text-[13px] px-3 py-1';
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded-full font-semibold ${sz} ${TONE_CLASSES[tone]} ${className}`}>
      {children}
    </span>
  );
}
